import { Locale, type LocalizedString } from "../Locale.js";

export const serviceEquipPathMap = {
	[Locale.cs]: "vybaveni-skladu" as const,
} satisfies LocalizedString;
